import * as React from "react";
import { Container } from "@grandvisionhq/elements";
/* empty css                  */
const Certificates = ({ children }) => {
  if (!children) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "certificates", "data-t": "certificates" }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("article", { className: "certificates__list" }, children)));
};
export {
  Certificates as default
};
//# sourceMappingURL=Certificates.js.map
